// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__ytjG_","calendarButtons":"ClockData_calendarButtons__1u8bZ"};